import formatDate from "functions/formatDate";
import { parseISO } from "date-fns";

const dueLabel = (date) => {
  if (date !== null) {
    return `Due ${formatDate(parseISO(date))}`;
  }
};

export default dueLabel;
